import { graphql } from '@/generated/gql';

export const DELETE_SMART_LINK_MUTATION = graphql(/* GraphQL */ `
  mutation DeleteSmartLink($id: UUID!) {
    astronaut {
      smartLink {
        remove(id: $id) {
          id
        }
      }
    }
  }
`);
